var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwentynine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: #f5f6f6;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        opacity: .57;\n      }\n\n      .cls-5 {\n        fill: #ccc;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.01,76.24h-20.75l-290.47,89.06L140.31,76.24h-20.75c-22.92,0-41.5,18.58-41.5,41.5v875.57c0,22.92,18.58,41.5,41.5,41.5h508.33l155.61-186.73V117.74c0-22.92-18.58-41.5-41.5-41.5h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.01,76.24h-20.75l-19.91,6.1c11.92,7.29,19.91,20.39,19.91,35.39v294.62h-103.74c-45.76,0-82.99,37.23-82.99,82.99v518.7c0,7.16.91,14.11,2.63,20.75h90.74l155.61-186.73V117.74c0-22.92-18.58-41.5-41.5-41.5h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M622.32,76.24l-191.53,45.65-191.53-45.65h-98.94v875.57c0,11.46,9.29,20.75,20.75,20.75h539.45c11.46,0,20.75-9.29,20.75-20.75V76.24h-98.94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.8,246.38v-29.05c0-9.17,7.43-16.6,16.6-16.6h298.77c9.17,0,16.6,7.43,16.6,16.6v29.05c0,9.17-7.43,16.6-16.6,16.6h-298.77c-9.17,0-16.6-7.43-16.6-16.6h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.17,200.73h-62.24c9.17,0,16.6,7.43,16.6,16.6v29.05c0,9.17-7.43,16.6-16.6,16.6h62.24c9.17,0,16.6-7.43,16.6-16.6v-29.05c0-9.17-7.43-16.6-16.6-16.6h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M659.02,76.25v336.12h-41.5c-45.76,0-82.99,37.23-82.99,82.99v477.21h165.99c11.46,0,20.75-9.29,20.75-20.75V76.25h-62.25Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.03,76.25c0-34.38-27.87-62.25-62.25-62.25s-62.25,27.87-62.25,62.25h-129.29c-8.81,0-15.95,7.14-15.95,15.95v30.35c0,8.81,7.14,15.95,15.95,15.95h383.06c8.81,0,15.95-7.14,15.95-15.95v-30.35c0-8.81-7.14-15.95-15.95-15.95h-129.28Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M949.49,474.61h-331.97c-11.46,0-20.75,9.29-20.75,20.75v337.76l12.12,14.95-12.12,14.95v151.03c0,11.46,9.29,20.75,20.75,20.75h151.03l201.69-201.68v-337.76c0-11.46-9.29-20.75-20.75-20.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M949.49,1034.81h-151.03l-14.95-19.94v-166.8h186.73v165.99c0,11.46-9.29,20.75-20.75,20.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M907.99,848.07v165.99c0,11.46-9.29,20.75-20.75,20.75h62.25c11.46,0,20.75-9.29,20.75-20.75v-165.99h-62.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M955.29,848.08l14.95-14.95v-337.76c0-11.46-9.29-20.75-20.75-20.75h-62.24c11.46,0,20.75,9.29,20.75,20.75v352.72h47.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M659.02,582.5v-29.05c0-9.17,7.43-16.6,16.6-16.6h215.78c9.17,0,16.6,7.43,16.6,16.6v29.05c0,9.17-7.43,16.6-16.6,16.6h-215.78c-9.17,0-16.6-7.43-16.6-16.6Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M721.26,739.75h-16.17v-16.17c0-8.26-6.7-14.95-14.95-14.95s-14.95,6.7-14.95,14.95v16.17h-16.17c-8.26,0-14.95,6.7-14.95,14.95s6.7,14.95,14.95,14.95h16.17v16.17c0,8.26,6.7,14.95,14.95,14.95s14.95-6.7,14.95-14.95v-16.17h16.17c8.26,0,14.95-6.7,14.95-14.95s-6.7-14.95-14.95-14.95Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M711.29,941.44l11.43-11.43c5.84-5.84,5.84-15.31,0-21.15-5.84-5.84-15.31-5.84-21.15,0l-11.43,11.43-11.43-11.43c-5.84-5.84-15.31-5.84-21.15,0-5.84,5.84-5.84,15.31,0,21.15l11.43,11.43-11.43,11.43c-5.84,5.84-5.84,15.31,0,21.15,2.92,2.92,6.75,4.38,10.57,4.38s7.65-1.46,10.57-4.38l11.43-11.43,11.43,11.43c2.92,2.92,6.75,4.38,10.57,4.38s7.65-1.46,10.57-4.38c5.84-5.84,5.84-15.31,0-21.15l-11.43-11.43Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M908,769.66h-62.25c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h62.25c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M908,925.27h-62.25c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h62.25c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M908,987.52h-62.25c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h62.25c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M798.46,833.12v-156.83h109.54c8.26,0,14.95-6.7,14.95-14.95s-6.7-14.95-14.95-14.95h-248.98c-8.26,0-14.95,6.7-14.95,14.95s6.7,14.95,14.95,14.95h109.54v156.83h-171.78v29.91h171.78v171.78h29.91v-171.78h171.78v-29.91h-171.78Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.89,381.67h-136.94c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h136.94c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.78,381.67h-41.5c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h41.5c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.89,443.92h-136.94c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h136.94c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.78,443.92h-41.5c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h41.5c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.89,506.16h-136.94c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h136.94c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.78,506.16h-41.5c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h41.5c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.89,568.4h-136.94c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h136.94c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.78,568.4h-41.5c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h41.5c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.78,692.89h-41.5c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h41.5c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.78,755.14h-41.5c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h41.5c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M513.78,630.65h-211.63c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h211.63c8.26,0,14.95,6.7,14.95,14.95s-6.69,14.95-14.95,14.95Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.78,831.91h-37.57c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h37.57c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.81,831.91h-74.69c-8.26,0-14.95-6.7-14.95-14.95s6.7-14.95,14.95-14.95h74.69c8.26,0,14.95,6.7,14.95,14.95s-6.7,14.95-14.95,14.95Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 430.79,
    cy: 76.23,
    r: 15.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 202.56,
    cy: 366.72,
    r: 15.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 202.56,
    cy: 428.96,
    r: 15.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 202.56,
    cy: 491.21,
    r: 15.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 202.56,
    cy: 553.45,
    r: 15.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentynine);
export default __webpack_public_path__ + "static/media/twentynine.39816e8bdd8ef85998437729332e8e30.svg";
export { ForwardRef as ReactComponent };